import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { TimeslotModel } from '@store/slices/timeslot.slice'
import { RootState } from '@store/store'
import { broadcastExtraReducers } from '@store/reducres/broadcast.reducers'

export const broadcastUrl = 'broadcast'

export interface BroadcastModel extends DjangoModel {
  headers: string
  slots: EntityId[]
  // areaHeader: string
  // authorHeader: string
  date: string
  published: boolean
  areaId: EntityId
  voiceId: EntityId
  audioId: EntityId
}

const {
  slice: broadcastSlice,
  thunks: broadcastThunks,
  adapter: broadcastAdapter,
  selectors,
} = createGenericSlice<BroadcastModel>(
  'broadcast',
  broadcastUrl,
  {},
  broadcastExtraReducers
)

export const broadcastAdapterExport = broadcastAdapter

export const {
  fetchAll: fetchAllBroadcasts,
  update: updateBroadcast,
  fetchById: fetchBroadcastById,
} = broadcastThunks
export const {
  selectAll: selectAllBroadcasts,
  selectById: selectBroadcastById,
} = broadcastAdapter.getSelectors<RootState>(
  (state: RootState) => state.broadcast
)
export const { removeAll: clearAllBroadcasts } = broadcastSlice.actions

export const {
  selectLoading: selectBroadcastLoading,
  selectIsIdInProgress: selectIsBroadcastIdInProgress,
  selectError: selectBroadcastError,
} = selectors

export default broadcastSlice.reducer
